export default "__VITE_ASSET__238c1f81__"